// extracted by mini-css-extract-plugin
module.exports = {"popup":"popup_popup__3TB8w"};